// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Tour/PDFHandlersTour.jsx

import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faCopy, faTimes } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/TourForm.module.scss';

const PDFHandlersTour = ({
  initialPDFs,
  pdfList,
  setPdfList,
  setToastMessage,
  setToastVariant,
  setShowToast
}) => {
  const fileInputRef = useRef(null);

  // Initialize pdfList only when initialPDFs changes and pdfList is empty
  useEffect(() => {
    if (pdfList.length === 0 && initialPDFs?.length > 0) {
      const initialPdfList = initialPDFs.map(pdf => ({
        id: Math.random().toString(36).substr(2, 9),
        file_original_url: pdf.file_original_url,
        file_resize_url: pdf.file_resize_url || '',
        isNew: false,
      }));
      setPdfList(initialPdfList);
    }
  }, [initialPDFs, pdfList.length, setPdfList]);

  const handlePDFChange = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const validPdfs = files.filter(file => file.type === 'application/pdf');
    if (validPdfs.length !== files.length) {
      setToastMessage('Only PDF files are allowed.');
      setToastVariant('danger');
      setShowToast(true);
    }

    if (validPdfs.length > 0) {
      const newPdfObjects = validPdfs.map(file => ({
        id: Math.random().toString(36).substr(2, 9),
        file_original_url: file.name,
        fileObject: file,
        isNew: true,
      }));
      setPdfList(prev => [...prev, ...newPdfObjects]);
    }

    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handlePDFRemove = (pdfIdToRemove) => {
    setPdfList(prev => prev.filter(pdf => pdf.id !== pdfIdToRemove));
  };

  const handleCopyUrl = (url) => {
    if (!url) return;
    navigator.clipboard.writeText(url)
      .then(() => {
        setToastMessage('URL copied to clipboard!');
        setToastVariant('info');
        setShowToast(true);
      })
      .catch(() => {
        setToastMessage('Failed to copy URL.');
        setToastVariant('danger');
        setShowToast(true);
      });
  };

  return (
    <div className={styles.formCard}>
      <div className={styles.cardBody}>
        <h5 className="card-title">Program PDFs</h5>
        <input
          type="file"
          className="form-control"
          accept=".pdf"
          multiple
          onChange={handlePDFChange}
          ref={fileInputRef}
        />
        <div className="mt-2">
          {(pdfList || []).map((pdf) => (
            <div key={pdf.id} className="input-group input-group-sm mb-2">
              <span className="form-control text-truncate" title={pdf.file_original_url}>
                {pdf.isNew ? `(New) ${pdf.file_original_url}` : pdf.file_original_url.split('/').pop()}
              </span>
              <a
                href={!pdf.isNew ? pdf.file_original_url : undefined}
                target="_blank"
                rel="noopener noreferrer"
                className={`btn btn-outline-secondary ${pdf.isNew ? 'disabled' : ''}`}
                title="View PDF"
              >
                <FontAwesomeIcon icon={faEye} />
              </a>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => handleCopyUrl(pdf.file_original_url)}
                disabled={pdf.isNew}
                title="Copy URL"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handlePDFRemove(pdf.id)}
                title="Remove"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PDFHandlersTour;